export default function generalConfig() {
    return({
        appVersion:"1.0.4",
        lastBuildDate:"2019-01-02",
        showBCAfter: "2019-01-11"
    })
}